import { Service } from "../service.js";
import { env } from "../env.js";

class DepartamentoService extends Service {
  constructor() {
    super();

    this.url = `${env.baseDocumento}departamentos-do-bureau`;
  }

  async listar(queryString = "?page[offset]=0") {
    queryString = queryString || '';
    queryString.trim();
    const url = `${this.url}${queryString}`;
    return await this.paginarDepartamentos(url);
  }

  async listarTodosDepartamentos() {
    var url = `${env.url}departamentos-do-bureau`;
    const departamentos = await this.get(url);
    return departamentos.map((element) => {
      return {
        value: parseInt(element.id),
        label: `${element.nome}`
      };
    });
  }

  async paginarDepartamentos(url) {
    let listaDp = []
    do {
      const response = await this.get(url);
      listaDp = listaDp.concat(response.data);
      url = response.links.next
    } while (url !== null)
    return listaDp.map((d) => {
      return {
        value: parseInt(d.id),
        label: `${d.attributes.nome}`,
        padrao: d.attributes.departamentoPadrao
      };
    });
  }

  async getLiderancas() {
    const url = `${env.url}departamentos-do-bureau/liderancas`;
    return await this.get(url);
  }
}

export const departamentoService = new DepartamentoService();
